import React from "react";
import Header from "./template/Header";
import Footer from "./template/Footer";
export default function Pcd(){
	
		 
	return (
    <div>
	<Header/>
    <section className="section-padding">
		<div className="container">
			<div className="row">
				
				<div className="col-lg-12 align-self-center">
					<div className="about-content">
						<h4>Pharma Pcd Franchise</h4>
						<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
						
					</div>
				</div>
			</div>
		</div>
	</section>
	<Footer />
	 </div>
  );
}